import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post("https://apnaqwebx-mern.onrender.com/api/auth/login", form);

      localStorage.setItem("admin-token", res.data.token);

      navigate("/admin");
    } catch (err) {
      alert(err.response?.data?.message || "Login failed");
    }
  };

  return (
<>
<div className=" mt-28">
  <h1 className="text-4xl font-bold text-[#895712] text-center">Admin Login</h1>
  <p className="text-gray-600 mt-2 text-center">Please enter your credentials to login.</p>

   
   <form
  onSubmit={handleLogin}
  className="mt-4 mb-8 bg-white shadow-xl p-8 rounded-xl max-w-md mx-auto border border-[#e7d5c2] space-y-6"
>

  {/* EMAIL FIELD */}
  <div>
    <label className="text-[#895712] text-sm font-semibold">Email</label>
    <div className="flex items-center border border-[#895712] rounded-lg px-3 mt-1">
      <i className="fa-solid fa-envelope text-[#895712]"></i>
      <input
        type="email"
        name="email"
        value={form.email}
        onChange={(e) => setForm({ ...form, email: e.target.value })}
        placeholder="Enter your email"
        className="w-full px-2 py-2 outline-none"
        required
      />
    </div>
  </div>

  {/* PASSWORD FIELD */}
  <div>
    <label className="text-[#895712] text-sm font-semibold">Password</label>
    <div className="flex items-center border border-[#895712] rounded-lg px-3 mt-1">
      <i className="fa-solid fa-lock text-[#895712]"></i>
      <input
        type="password"
        name="password"
        value={form.password}
        onChange={(e) => setForm({ ...form, password: e.target.value })}
        placeholder="Enter your password"
        className="w-full px-2 py-2 outline-none"
        required
      />
    </div>
  </div>

  {/* SUBMIT BUTTON */}
  <button
    type="submit"
    className="w-full bg-[#895712] text-white py-3 rounded-lg font-semibold shadow-md hover:bg-red transition"
  >
    Login
  </button>
</form>
</div>
  </>);
}
